import { NGX_LOGGER_CONFIG, NGX_LOGGER_LEVELS, NgxLoggerConfig } from '@allianz/ngx-logger';
import { NdbxIconModule } from '@allianz/ngx-ndbx/icon';
import { HashOnlyLocationStrategy } from '@allianz/ngx-pfe';
import { LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NxBadgeModule } from '@aposin/ng-aquila/badge';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ClarityLegacyModule } from './clarity-legacy/clarity-legacy.module';
import { LandingPageComponent } from './landingpage/landingpage.component';
import { UtilsModule } from './utils/utils.module';

@NgModule({
  declarations: [AppComponent, LandingPageComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule, //
    BrowserAnimationsModule,
    ClarityLegacyModule,
    AppRoutingModule,
    UtilsModule,
    NxBadgeModule,
    NdbxIconModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashOnlyLocationStrategy },
    {
      provide: NGX_LOGGER_CONFIG,
      useValue: {
        console: {
          level: NGX_LOGGER_LEVELS.DEBUG,
          appendLevel: true,
          appendTimestamp: true,
        },
      } as NgxLoggerConfig,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
